import React, { FC, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { callApi } from "../helpers/CallAPI";
import { apiBaseUrl, apiPaths } from "../constants/ApiUrl";
import { SESSION_TIMEOUT } from "../constants/common";

const Login: FC = () => {
  const [apiKey, setApiKey] = useState<string>("");
  const [apiKeyError, setApiKeyError] = useState<string>("");

  const navigate = useNavigate();

  const handleAuthorize = () => {
    if (apiKey.trim()) {
      callApi(apiKey, apiBaseUrl + apiPaths.auth, "GET").then((data) => {
        const expirationTime = Date.now() + SESSION_TIMEOUT;
        const apiKeyData = {
            key: apiKey,
            expiry: expirationTime
        }
        const mapGLData = {
            key: data.mapgl_token,
            expiry: expirationTime
        }
        localStorage.setItem("mapGL", JSON.stringify(mapGLData)) // Save access token of mapGL from api after authenticate
        localStorage.setItem("apiKey", JSON.stringify(apiKeyData)); // Save API key in local storage
        navigate("/dashboard"); // Redirect to a protected route
      }).catch((e) => {
        const error = JSON.parse(e.message)
        if (error.status === 403) {
          setApiKeyError("Invalid API key.")
        }
      })
    } else {
      setApiKeyError("Please input the API key.")
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#121212",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            width: "400px",
            padding: "20px 40px 40px 40px",
            backgroundColor: "#1e1e1e", // Slightly lighter background for the card
            borderRadius: "8px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          }}
        >
          <Typography
            variant="h5"
            component="h1"
            sx={{ textAlign: "center", color: "#ffffff", marginBottom: "20px" }}
          >
            Sea Monitoring
          </Typography>
          <TextField
            label="API Key"
            placeholder="Enter your API Key"
            variant="outlined"
            onChange={(e) => {
              if (e.target.value.trim()) {
                setApiKeyError("")
              } else {
                setApiKeyError("Please input the API key")
              }
              setApiKey(e.target.value)
            }}
            fullWidth
            sx={{
              "& .MuiInputLabel-root": { color: "#b0b0b0" }, // Label color
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#444" },
                "&:hover fieldset": { borderColor: "#888" },
                "&.Mui-focused fieldset": { borderColor: "#1976d2" }, // Focused state
              },
              input: { color: "#ffffff"}, // Input text color
              
            }}
            error={apiKeyError.trim() ? true: false}
            helperText={
              apiKeyError.trim() ? apiKeyError: "" 
            }
          />
          <Button
            variant="contained"
            fullWidth
            onClick={() => handleAuthorize()}
            sx={{
              marginTop: "30px",
              height: "50px",
              backgroundColor: "#1976d2", // Button color
              color: "#ffffff",
              "&:hover": { backgroundColor: "#155a9c" },
              textTransform: "none",
              fontSize: "1rem",
              lineHeight: "1.4375em",
              letterSpacing: "0.00938em",
            }}
          >
            Authorize
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default Login;
